import { gql } from "@apollo/client";

import { tosFragment } from "../fragments";

export const getTos = gql`
    query getTos($key: TosKey!) {
        getTos(input: { key: $key }) {
            tos {
                ...Tos
            }
        }
    }
    ${tosFragment}
`;
